/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetGradeByGroupID,
    GetExestingOrderAllocationConfigurationData,
    SaveOrderAllocationConfigurationData,
    GetOrderAllocationConfigurationData,
    GetorderAllocationConfigurationDataById,
    UpdateOrderAllocationConfigurationData,
    GetAllPriority,
    GetFactoriesByGradeID,
    GetOutletByGroupID
};

async function GetAllGroups() {
    const response = await CommonGet('/api/OutletScreen/GetAllGroupsForOutletScreen', null);
    return response.data;
}

async function GetGradeByGroupID(groupID) {
    const response = await CommonGet('/api/OrderAllocationConfiguration/GetGradeByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetExestingOrderAllocationConfigurationData(model) {
    const response = await CommonPost('/api/OrderAllocationConfiguration/GetExestingOrderAllocationConfigurationData', null, model);
    return response;
}

async function SaveOrderAllocationConfigurationData(model) {
    const response = await CommonPost('/api/OrderAllocationConfiguration/SaveOrderAllocationConfigurationData', null, model);
    return response;
}

async function GetOrderAllocationConfigurationData(model) {
    const response = await CommonPost('/api/OrderAllocationConfiguration/GetOrderAllocationConfigurationData', null, model);
    return response;
}

async function GetorderAllocationConfigurationDataById(orderAllocationConfigurationID) {
    const response = await CommonGet('/api/OrderAllocationConfiguration/GetorderAllocationConfigurationDataById', 'orderAllocationConfigurationID=' + parseInt(orderAllocationConfigurationID));
    return response.data;
}

async function UpdateOrderAllocationConfigurationData(model) {
    const response = await CommonPost('/api/OrderAllocationConfiguration/UpdateOrderAllocationConfigurationData', null, model);
    return response;
}

async function GetAllPriority() {
    const response = await CommonGet('/api/OrderAllocationConfiguration/GetAllPriority', null);
    return response.data;
}


async function GetFactoriesByGradeID(gradeID) {
    const response = await CommonGet('/api/OrderAllocationConfiguration/GetFactoriesByGradeID', 'gradeID=' + parseInt(gradeID));
    return response.data;
}

async function GetOutletByGroupID(groupID) {
    const response = await CommonGet('/api/CustomerOrdersOutletWise/GetOutletByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}